import { cn } from '@/lib/cn';
import { Loader2 } from 'lucide-react';

export function Spinner({ className, size = 18 }: { className?: string; size?: number }) {
  return <Loader2 className={cn('animate-spin text-[var(--fg-muted)]', className)} size={size} />;
}
